module.exports = __webpack_public_path__ + "staticcomp/img/share.8fe4949.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/10/share.jpg
// module id = I4OR
// module chunks = 39